import { Injectable } from "@angular/core";
import { Route, Router } from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class RotaService{
    constructor(private router: Router){}

    navegarPara(url: string){
        this.router.navigate([url])
    }
}